import { render } from "./userPasswordModify.vue?vue&type=template&id=99b18532&scoped=true"
import script from "./userPasswordModify.vue?vue&type=script&lang=js"
export * from "./userPasswordModify.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_2021\\项目管理系统\\TYH_office_automation\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99b18532"]])

export default __exports__